export const OBRAS = ['Benjamin Constant', 'Lumière', 'Ingarden', 'Escritório', 'Manutenção', 'Externo'];

export const STATUS_PEDIDO = {
  aguardando:       { label: 'Aguardando Entrega', color: 'bg-yellow-100 text-yellow-700' },
  recebido_parcial: { label: 'Recebido Parcial',   color: 'bg-blue-100 text-blue-700' },
  recebido_total:   { label: 'Recebido Total',      color: 'bg-green-100 text-green-700' },
  cancelado:        { label: 'Cancelado',            color: 'bg-red-100 text-red-700' },
};

export const STATUS_NF = {
  aguardando_ocr:        { label: 'Aguardando OCR',   color: 'bg-gray-100 text-gray-600' },
  aguardando_validacao:  { label: 'Aguardando Valid.', color: 'bg-yellow-100 text-yellow-700' },
  validada:              { label: 'Validada',          color: 'bg-green-100 text-green-700' },
  erro:                  { label: 'Erro',              color: 'bg-red-100 text-red-700' },
};

export function StatusBadge({ value, map }) {
  const cfg = map[value] || { label: value, color: 'bg-gray-100 text-gray-500' };
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${cfg.color}`}>{cfg.label}</span>;
}

export function fmt(n, dec = 2) {
  if (n === null || n === undefined) return '—';
  return parseFloat(n).toFixed(dec).replace('.', ',');
}

export function fmtMoeda(n) {
  if (!n) return '—';
  return 'R$ ' + parseFloat(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
